<div class="flex gap-3 justify-center items-center">
  @if (phase![statusSelected].iD_STATUS !== 16) {
    <div class="text-base font-bold text-primary text-white">
      {{ 'workflow.changeStatus' | translate }}
    </div>
  }
  <div class="flex gap-3">
    @if (phase![statusSelected].iD_STATUS !== 16) {
      @for (button of statusButtons; track button; let i = $index) {
        @if (button.description != '') {
          <button
            [matTooltip]="button.tolltip | translate"
            (click)="indexSelect(i)"
            class="rounded-md size-10! border-2! bg-white! border-(--comp-icon-color-secondary)! justify-center items-center inline-flex!"
            matIconButton
            [ngClass]="{
              'border-red-500! ': button.icon === 'close' || button.icon === 'cancel',
            }"
          >
            <mat-icon
              [ngClass]="{
                'text-red-500!': button.icon === 'close' || button.icon === 'cancel',
              }"
              class="text-(--comp-icon-color-secondary)!"
            >
              {{ button.icon }}
            </mat-icon>
          </button>
        }
      }
    }
    <button
      matTooltip="{{ 'workflow.back' | translate }}"
      class="rounded-md size-10! border-2! bg-white! border-(--comp-icon-color-secondary)! justify-center items-center inline-flex!"
      matIconButton
      (click)="back.emit(expansion)"
    >
      <mat-icon class="text-(--comp-icon-color-secondary)!"> undos </mat-icon>
    </button>

    <button
      matTooltip="{{
        !expansion ? ('workflow.maximize' | translate) : ('workflow.minimize' | translate)
      }}"
      class="rounded-md size-10! border-2! bg-white! border-(--comp-icon-color-secondary)! justify-center items-center inline-flex!"
      matIconButton
      (click)="expansion = !expansion; emitExpansion.emit(expansion)"
    >
      <mat-icon class="text-(--comp-icon-color-secondary)!">
        {{ !expansion ? 'fit_screen' : 'fullscreen_exit' }}
      </mat-icon>
    </button>
  </div>
</div>
